import { Chip } from '@liveauctioneers/hammer-ui-core/chips';
import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

import { useNavigateSearchPageWithParams } from '@/pages/Search/SearchPage/hooks/useNavigateSearchPageWithParams';
import { RelatedSearchItem } from '@/redux/modules/search/relatedSearches/relatedSearches.types';
import { FilterAction } from '@/types/SearchFacet';
import { useTrackSearchSuggestionClicked } from '@/utils/amplitude/analytics';
import { getSearchUrlWithParams } from '@/utils/urls';

type SuggestionChipProps = {
    position: number;
    suggestion: RelatedSearchItem;
};

export const SuggestionChip = ({ position, suggestion }: SuggestionChipProps) => {
    const navigateSearchPageWithParams = useNavigateSearchPageWithParams();
    const trackSearchSuggestionClicked = useTrackSearchSuggestionClicked();
    const href = getSearchUrlWithParams({ keyword: suggestion.query, page: 1 });

    const handleClick = () => {
        trackSearchSuggestionClicked({
            suggestedClickPosition: position,
            suggestedQueryClicked: suggestion.query,
            url: href,
        });
        navigateSearchPageWithParams({
            filterAction: FilterAction.FilterTermAdded,
            params: { keyword: suggestion.query, page: 1 },
            suggestionClicked: true,
        });
    };

    return (
        <Chip
            aria-label={`Related search: ${suggestion.query}`}
            className="min-h-[42px] w-max shrink-0 items-center gap-2xs overflow-visible p-sm pl-3xs"
            onClick={handleClick}
            size="md"
            style="suggestion"
        >
            {suggestion.firstResultLotDetails?.imageUrl && (
                <img
                    alt={`${suggestion.query} thumbnail`}
                    className="h-[38px] w-[38px] shrink-0 rounded-full object-cover"
                    data-testid="related-search-thumbnail"
                    src={suggestion.firstResultLotDetails.imageUrl}
                />
            )}
            <BodySecondary className="whitespace-nowrap">{suggestion.query}</BodySecondary>
        </Chip>
    );
};
